import * as React from 'react';
import {
    Tab as ReactTab,
    TabList as ReactTabList,
    TabPanel as ReactTabPanel,
    Tabs as ReactTabs,
    TabsProps as ReactTabsProps
} from 'react-tabs';

import { Bem } from '../../service/Bem/Bem';

import './Tabs.css';

export enum TabsSize {
    s = 's',
    m = 'm'
}

export interface TabsProps extends ReactTabsProps {
    size: TabsSize;
}

export class Tabs extends React.PureComponent<TabsProps> {
    render() {
        const { size, ...props } = this.props;

        return (
            <ReactTabs
                {...props as ReactTabsProps}
                className={Bem.cls({
                    block: 'tabs',
                    mods: { size }
                })}
                disabledTabClassName={Bem.cls('tabs', 'item', {
                    disabled: 'yes'
                })}
                selectedTabClassName={Bem.cls('tabs', 'item', {
                    active: 'yes'
                })}
            >
                {this.props.children}
            </ReactTabs>
        );
    }
}

export const Tab = ReactTab;
export const TabList = ReactTabList;
export const TabPanel = ReactTabPanel;
